module.exports = __webpack_public_path__ + "static/food1-9fcd99aa2f1ff7bc7d372f6dd7ea8e59.jpg";